import type {
  MineableSpec,
  ModuleCategory,
  ModuleDef,
  ReactorSpec,
  Stats,
  ThrusterPort,
  WeaponSpec,
} from "../types";
import { STEEL_J_PER_KG_K } from "../thermal";

export const ZERO_STATS: Stats = {
  mass: 0,
  hp: 0,
  tensile: 0,
  hardness: 0,
  crew: 0,
  crewCapacity: 0,
  powerIdleW: 0,
  powerActiveW: 0,
  powerOutW: 0,
  batteryWh: 0,
  energyEfficiency: 1,
  thermalConductivity: 1,
  thermalEmissivity: 0.7,
  surfaceAreaMult: 1,
  meltPointK: 1700,
  fuelCapacityKg: 0,
  cargoCapacityKg: 0,
  temperature: 2.7,
  valuePerKg: 0,
  crewTraversable: true,
  requiresCockpit: false,
  thermalInertia: STEEL_J_PER_KG_K,
};

interface ModuleInput {
  id: string;
  name: string;
  category: ModuleCategory;
  tier: number;
  cells: { w: number; h: number };
  sprite: string;
  stats: Partial<Stats>;
  weapon?: WeaponSpec;
  thrusters?: readonly ThrusterPort[];
  mineable?: MineableSpec;
  reactor?: ReactorSpec;
  hasStatusIndicator?: boolean;
  collector?: boolean;
  noCollision?: boolean;
}

export function defineModule(input: ModuleInput): ModuleDef {
  const stats: Stats = { ...ZERO_STATS, ...input.stats };
  return {
    id: input.id,
    name: input.name,
    category: input.category,
    tier: input.tier,
    cells: input.cells,
    sprite: input.sprite,
    stats,
    ...(input.weapon ? { weapon: input.weapon } : {}),
    ...(input.thrusters ? { thrusters: input.thrusters } : {}),
    ...(input.mineable ? { mineable: input.mineable } : {}),
    ...(input.reactor ? { reactor: input.reactor } : {}),
    ...(input.hasStatusIndicator !== undefined
      ? { hasStatusIndicator: input.hasStatusIndicator }
      : {}),
    ...(input.collector ? { collector: true } : {}),
    ...(input.noCollision ? { noCollision: true } : {}),
  };
}
